import { render, staticRenderFns } from "./ASC_FindingSummaryCPT.vue?vue&type=template&id=fbff19b6&scoped=true&"
import script from "./ASC_FindingSummaryCPT.vue?vue&type=script&lang=js&"
export * from "./ASC_FindingSummaryCPT.vue?vue&type=script&lang=js&"
import style0 from "./ASC_FindingSummaryCPT.vue?vue&type=style&index=0&id=fbff19b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff19b6",
  null
  
)

export default component.exports